
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: 
          "text-foreground",
        success:
          "border-transparent bg-green-500 text-white hover:bg-green-600",
        // Custom badge variants for invoice statuses
        unpaid:
          "bg-white border-2 border-primary text-foreground hover:bg-slate-50",
        pending:
          "bg-white border-2 border-primary text-foreground hover:bg-slate-50 [background-image:linear-gradient(45deg,transparent_25%,rgba(14,165,233,0.2)_25%,rgba(14,165,233,0.2)_50%,transparent_50%,transparent_75%,rgba(14,165,233,0.2)_75%,rgba(14,165,233,0.2))]",
        paid:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        overdue:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
